import { TopologicalEditorController } from '../../page/topological.editor.page';

export abstract class TopologicalEditorToolController {
	constructor(public topologicalEditorController: TopologicalEditorController) {}

	abstract destroy(): void;
}
